const rules = {
  required: value => !!value || 'This field is required.',
  email: value =>
    /.+@.+\..+/.test(value) || 'E-mail must be valid.',
  password: value => (value && value.length >= 8) || 'Password must be at least 8 characters.'

};
export default rules;
